export default {"src":"/_next/static/media/dashboard.ec746c9e.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};